let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("Wowvf"), load("bkswC")]).then(() => parcelRequire('lhO3J'));